import type { IconSvgObject } from './types';

const BootstrapIcon: IconSvgObject = [
  ["path", { d: "M12.8824 12C14.0519 12 15 12.8954 15 14C15 15.1046 14.0519 16 12.8824 16H9V12M12.8824 12C14.0519 12 15 11.1046 15 10C15 8.89543 14.0519 8 12.8824 8H9V12M12.8824 12H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 6L4 10C4 11.1046 3.10457 12 2 12C3.10457 12 4 12.8954 4 14L4 18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V14C20 12.8954 20.8954 12 22 12C20.8954 12 20 11.1046 20 10V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BootstrapIcon;
